import { useState } from 'react'
import { Button, Snackbar, Alert } from '@mui/material'
import { colors } from '../theme'
import { AdoptersClient } from '../../interactors/clients/AdoptersClient'

interface PromoButtonProps {
  promoCode: string
  offerId: string
  animalName: string
  animalId: string
}

export function PromoButton({ promoCode, offerId, animalName, animalId }: PromoButtonProps) {
  const [showCode, setShowCode] = useState(false)
  const [copied, setCopied] = useState(false)

  const onSubmit = () => {
    AdoptersClient.sendMonitoringRequest({
      message: `Code promo découvert pour ${offerId}`,
      animalName: animalName,
      animalId: animalId,
    })
  }

  const handleClick = async () => {
    // Reveal the code in the button
    onSubmit()
    setShowCode(true)

    // Copy to clipboard
    try {
      await navigator.clipboard.writeText(promoCode)
      setCopied(true)
    } catch (err) {
      console.error('Copy failed', err)
      // (optionally) show an error snackbar here
    }
  }

  return (
    <>
      {promoCode && (
        <Button
          variant="outlined"
          onClick={handleClick}
          sx={{
            color: colors.blueSky,
            borderColor: colors.blueSky,
            mb: 2,
            py: '8px',
            px: '16px',
            borderRadius: '24px',
            fontWeight: 'bold',
            fontSize: '1rem',
            width: '100%',
            '&:hover': {
              borderColor: colors.blueSky,
            },
          }}
        >
          {showCode ? promoCode : 'Obtenir mon code'}
        </Button>
      )}

      <Snackbar
        open={copied}
        autoHideDuration={3000}
        onClose={() => setCopied(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setCopied(false)} severity="success" sx={{ width: '100%' }}>
          Code copié !
        </Alert>
      </Snackbar>
    </>
  )
}
